export default {
	optionSelectStyle: {
	}
};
